import { z } from "zod";

const zSchema = z.string();
type Schema = z.infer<typeof zSchema>;

export { zSchema };
export type { Schema };
